import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core'

import { EventsService } from '../../services/events.service'
import { UsersService } from '../../services/users.service'
import { MessagesDelegate } from '../../services/messages-delegate.service'
import { config } from '../../config/config'

import { SuiModalService } from 'ng2-semantic-ui'
import { ConfirmModal } from '../confirm-modal/confirm-modal.component'

import { Event } from '../../models/event.model'
import { Comment } from '../../models/comment.model'
import { ParserService } from '../../services/parser.service'

@Component({
  selector: 'ld-comment-form',
  template: require('./comment-form.component.html'),
  styles: [require('./comment-form.component.css')],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CommentFormComponent {
  @Input('event') event: Event
  @Output('eventChange') eventChange = new EventEmitter<Event>()
  private newComment = new Comment()
  private editedComment = { id: '', body: '' }
  private debounceTime = config.debounceTime

  constructor (
    private eventsService: EventsService,
    private usersService: UsersService,
    private messagesDelegate: MessagesDelegate,
    private modalService: SuiModalService,
    private parseService: ParserService) {}

  async onSubmit () {
    this.newComment.author.id = this.usersService.currentUser.id
    this.newComment.eventId = this.event.id

    try {
      const comment = await this.eventsService.postComment(this.newComment.toRequestData())
      this.event.comments.unshift(comment)
      this.eventChange.emit(this.event)
      this.newComment = new Comment()
    } catch (e) {
      this.messagesDelegate.add(e.message)
    }
  }

  editComment (comment: Comment) {
    this.editedComment.id = comment.id
    this.editedComment.body = comment.body
  }

  async deleteComment (index) {
    this.modalService
      .open(new ConfirmModal('Suppression', 'Le commentaire sera supprimé. Continuer ?'))
      .onApprove(async () => {
        try {
          await this.eventsService.deleteComment(this.event.id, this.event.comments[index].id)
          this.event.comments.splice(index, 1)
          this.eventChange.emit(this.event)
        } catch (e) {
          this.messagesDelegate.add(e.message)
        }
      })
  }

  async onEdit (index: number) {
    const edited = new Comment().cast(this.event.comments[index])
    edited.body = this.editedComment.body

    try {
      this.event.comments[index] = await this.eventsService.putComment(edited.toRequestData())
      this.eventChange.emit(this.event)
      this.editedComment.id = ''
    } catch (e) {
      this.messagesDelegate.add(e.message)
    }
  }

  /** Create elements for links and img for images */
  parseLinks (comment) {
    comment.body = this.parseService.autolink(comment.body)
  }
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/components/comment-form/comment-form.component.ts